<template>
    <div class="main-right-side">
        <div class="calc-results-table-scroll">
            <table class="calc-results-table">
                <thead>
                    <tr class="calc-results-head">
                        <th width="23%" role="cell"></th>
                        <th width="21%">{{ tableHeading().standard }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="standardDescription" /></th>
                        <th width="14%">{{ tableHeading().ibr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="ibrDescription" /></th>
                        <th width="14%">{{ tableHeading().icr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="icrDescription" /></th>
                        <th width="14%">{{ tableHeading().paye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="payeDescription" /></th>
                        <th width="14%">{{ tableHeading().repaye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="repayeDescription" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>First month's payment</td>
                        <td>
                            <div class="th-heading">{{ tableHeading().standard }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="standardDescription" /></div><span>{{ formattingTableCellValue(firstMonthPayment.standard) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().ibr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="ibrDescription" />
                            </div><span>{{ formattingTableCellValue(firstMonthPayment.incomeBasedRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().icr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="icrDescription" />
                            </div><span>{{ formattingTableCellValue(firstMonthPayment.incomeContingentRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().paye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="payeDescription" />
                            </div><span>{{ formattingTableCellValue(firstMonthPayment.payAsYouEarn) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().repaye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="repayeDescription" />
                            </div><span>{{ formattingTableCellValue(firstMonthPayment.repaymentPayAsEarn) }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Last month’s payment</td>
                        <td>
                            <div class="th-heading">Standard<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="standardDescription" /></div><span>{{ formattingTableCellValue(LastMonthPayment.standard) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().ibr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="ibrDescription" />
                            </div><span>{{ formattingTableCellValue(LastMonthPayment.incomeBasedRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().icr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="icrDescription" />
                            </div><span>{{ formattingTableCellValue(LastMonthPayment.incomeContingentRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().paye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="payeDescription" />
                            </div><span>{{ formattingTableCellValue(LastMonthPayment.payAsYouEarn) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().repaye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="repayeDescription" />
                            </div><span>{{ formattingTableCellValue(LastMonthPayment.repaymentPayAsEarn) }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Total balance paid</td>
                        <td>
                            <div class="th-heading">Standard<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="standardDescription" /></div><span>{{ formattingTableCellValue(totalBalancePaid.standard) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().ibr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="ibrDescription" />
                            </div><span>{{ formattingTableCellValue(totalBalancePaid.incomeBasedRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().icr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="icrDescription" />
                            </div><span>{{ formattingTableCellValue(totalBalancePaid.incomeContingentRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().paye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="payeDescription" />
                            </div><span>{{ formattingTableCellValue(totalBalancePaid.payAsYouEarn) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().repaye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="repayeDescription" />
                            </div><span>{{ formattingTableCellValue(totalBalancePaid.repaymentPayAsEarn) }}</span>
                        </td>
                    </tr>
                    <tr class="highlight">
                        <td>Total forgiveness</td>
                        <td>
                            <div class="th-heading">Standard<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="standardDescription" /></div><span>{{ formattingForgivenessValue(totalForegiveness.standard) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().ibr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="ibrDescription" />
                            </div><span>{{ formattingForgivenessValue(totalForegiveness.incomeBasedRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().icr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="icrDescription" />
                            </div><span>{{ formattingForgivenessValue(totalForegiveness.incomeContingentRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().paye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="payeDescription" />
                            </div><span>{{ formattingForgivenessValue(totalForegiveness.payAsYouEarn) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().repaye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="repayeDescription" />
                            </div><span>{{ formattingForgivenessValue(totalForegiveness.repaymentPayAsEarn) }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Repayment term</td>
                        <td>
                            <div class="th-heading">Standard<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="standardDescription" /></div><span>{{ convertInYears(rePaymentTerm.standard) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().ibr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="ibrDescription" />
                            </div><span>{{ convertInYears(rePaymentTerm.incomeBasedRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().icr }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="icrDescription" />
                            </div><span>{{ convertInYears(rePaymentTerm.incomeContingentRepayment) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().paye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="payeDescription" />
                            </div><span>{{ convertInYears(rePaymentTerm.payAsYouEarn) }}</span>
                        </td>
                        <td>
                            <div class="th-heading">{{ tableHeading().repaye }}<tooltip-view label="?" :show-on-over="ShowOnOver" :popper-content="repayeDescription" />
                            </div><span>{{ convertInYears(rePaymentTerm.repaymentPayAsEarn) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="payment-tabs-wrap">
            <ul class="payment-tabs">
                <li :class="defaultChartLoad === 'first_payment' ? 'active' : '' "><a @click="getActiveTabData('first_payment')">First Month’s Payment</a></li>
                <li :class="defaultChartLoad === 'finalPayment' ? 'active' : '' "><a @click="getActiveTabData('finalPayment')">Final Payment</a></li>
                <li :class="defaultChartLoad === 'totalAmountPaid' ? 'active' : '' "><a @click="getActiveTabData('totalAmountPaid')">Total Balance Paid</a></li>
                <li :class="defaultChartLoad === 'totalForgiveness' ? 'active' : '' "><a @click="getActiveTabData('totalForgiveness')">Total Forgiveness</a></li>
            </ul>
            <div class="payment-tab-contents">
                <div id="firstMonthPayment" class="tab-contents active">
                    <div class="visual-results">
                        <div v-for="(item,index) in getVisualGraphCalculation()" :key="index" class="visual-results-stroke">
                            <h4 class="visual-results-title ">{{ item.name }}</h4>
                            <div class="visual-results-block">
                                <div :class="`visual-inside ${item.class}`" :style="{'width': + item.chartWidth.insideWidth + '%'}"></div>
                                <div class="visual-value">${{ item.value }}</div>
                            </div>
                        </div>
                        <div class="visual-stroke-titles">
                            <div v-for="(item,index) in getVisualStoreTitles()" :key="index" class="visual-results-values">
                                {{ formatValueWithComma(item) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import {
        compact, get, isNull, map, max,
    } from 'lodash-es';
    import tooltipView from '~/components/tooltip-view.vue';
    import constant from '../helpers/constant';

    const defaultNumberOfMonths = 120;

    export default {
        props: {
            data: {
                Type: Object,
                default: {},
            },
            showOnOver: {
                default: true,
            },
            standardDescription: {
                Type: String,
                default: '10-year Standard Repayment Plan. Payments on this plan count towards the 120 payment total, but borrowers cannot stay on this plan to receive forgiveness with PSLF. See “Which payment plans are eligible for PSLF?” in the FAQ section below.',
            },
            ibrDescription: {
                Type: String,
                default: 'Income-Based Repayment (IBR) limits payments to 15% of discretionary income. Assumes borrowing started before July 1, 2014. If borrowing started on or after July 1, 2014, see calculation in “PAYE” column instead. Parent PLUS Loans are not eligible.',
            },
            icrDescription: {
                Type: String,
                default: 'Income-Contingent Repayment (ICR) limits payments to the lesser of 20% of discretionary income or an income-adjusted 12-year repayment amount . Parent PLUS loans are eligible if consolidated in a Direct Consolidation Loan.',
            },
            payeDescription: {
                Type: String,
                default: 'Pay As You Earn (PAYE) limits payments to 10% of discretionary income. Must have started borrowing on or after Oct. 1, 2007 to be eligible. Parent PLUS Loans are not eligible.',
            },
            repayeDescription: {
                Type: String,
                default: 'Revised Pay As You Earn (REPAYE limits payments to 10% of discretionary income. All federal Direct Loan types and borrowers are eligible except for Parent PLUS loans.',
            },
        },
        data() {
            return {
                ShowOnOver: this.showOnOver,
                defaultChartLoad: 'first_payment',
            };
        },
        components: {
            tooltipView,
        },
        computed: {
            firstMonthPayment() {
                return {
                    standard: get(this.data, 'standard.firstMonthPayment', '-'),
                    incomeBasedRepayment: get(this.data, 'incomeBasedRepaymentResult.firstMonthPayment', '-'),
                    incomeContingentRepayment: get(this.data, 'incomeContingentRepaymentResult.firstMonthPayment', '-'),
                    payAsYouEarn: get(this.data, 'payAsYouEarnResult.firstMonthPayment', '-'),
                    repaymentPayAsEarn: get(this.data, 'repaymentPayAsEarnResult.firstMonthPayment', '-'),
                };
            },
            LastMonthPayment() {
                return {
                    standard: get(this.data, 'standard.finalPayment', '-'),
                    incomeBasedRepayment: get(this.data, 'incomeBasedRepaymentResult.finalPayment', '-'),
                    incomeContingentRepayment: get(this.data, 'incomeContingentRepaymentResult.finalPayment', '-'),
                    payAsYouEarn: get(this.data, 'payAsYouEarnResult.finalPayment', '-'),
                    repaymentPayAsEarn: get(this.data, 'repaymentPayAsEarnResult.finalPayment', '-'),
                };
            },
            totalBalancePaid() {
                return {
                    standard: get(this.data, 'standard.totalAmountPaid', '-'),
                    incomeBasedRepayment: get(this.data, 'incomeBasedRepaymentResult.totalAmountPaid', '-'),
                    incomeContingentRepayment: get(this.data, 'incomeContingentRepaymentResult.totalAmountPaid', '-'),
                    payAsYouEarn: get(this.data, 'payAsYouEarnResult.totalAmountPaid', '-'),
                    repaymentPayAsEarn: get(this.data, 'repaymentPayAsEarnResult.totalAmountPaid', '-'),
                };
            },
            totalForegiveness() {
                return {
                    standard: get(this.data, 'standard.totalForgiveness', '-'),
                    incomeBasedRepayment: get(this.data, 'incomeBasedRepaymentResult.totalForgiveness', '-'),
                    incomeContingentRepayment: get(this.data, 'incomeContingentRepaymentResult.totalForgiveness', '-'),
                    payAsYouEarn: get(this.data, 'payAsYouEarnResult.totalForgiveness', '-'),
                    repaymentPayAsEarn: get(this.data, 'repaymentPayAsEarnResult.totalForgiveness', '-'),
                };
            },
            rePaymentTerm() {
                return {
                    standard: get(this.data, 'standard.repaymentPeriod', '-'),
                    incomeBasedRepayment: get(this.data, 'incomeBasedRepaymentResult.repaymentPeriod', '-'),
                    incomeContingentRepayment: get(this.data, 'incomeContingentRepaymentResult.repaymentPeriod', '-'),
                    payAsYouEarn: get(this.data, 'payAsYouEarnResult.repaymentPeriod', '-'),
                    repaymentPayAsEarn: get(this.data, 'repaymentPayAsEarnResult.repaymentPeriod', '-'),
                };
            },
            getVisualData() {
                return [
                    {
                        name: 'first_payment',
                        title: 'First Month’s Payment',
                        type: 'balance',
                        fields: [
                            {
                                title: this.tableHeading().standard,
                                value: get(this.data, 'standard.firstMonthPayment'),
                            },
                            {
                                title: this.tableHeading().ibr,
                                value: get(this.data, 'incomeBasedRepaymentResult.firstMonthPayment'),
                            },
                            {
                                title: this.tableHeading().icr,
                                value: get(this.data, 'incomeContingentRepaymentResult.firstMonthPayment'),
                            },
                            {
                                title: this.tableHeading().paye,
                                value: get(this.data, 'payAsYouEarnResult.firstMonthPayment'),
                            },
                            {
                                title: this.tableHeading().repaye,
                                value: get(this.data, 'repaymentPayAsEarnResult.firstMonthPayment'),
                            },
                        ],
                    },
                    {
                        name: 'finalPayment',
                        title: 'Final Payment',
                        type: 'balance',
                        fields: [
                            {
                                title: this.tableHeading().standard,
                                value: get(this.data, 'standard.finalPayment'),
                            },
                            {
                                title: this.tableHeading().ibr,
                                value: get(this.data, 'incomeBasedRepaymentResult.finalPayment'),
                            },
                            {
                                title: this.tableHeading().icr,
                                value: get(this.data, 'incomeContingentRepaymentResult.finalPayment'),
                            },
                            {
                                title: this.tableHeading().paye,
                                value: get(this.data, 'payAsYouEarnResult.finalPayment'),
                            },
                            {
                                title: this.tableHeading().repaye,
                                value: get(this.data, 'repaymentPayAsEarnResult.finalPayment'),
                            },
                        ],
                    },
                    {
                        name: 'totalAmountPaid',
                        title: 'Total balance paid',
                        type: 'balance',
                        fields: [
                            {
                                title: this.tableHeading().standard,
                                value: get(this.data, 'standard.totalAmountPaid'),
                            },
                            {
                                title: this.tableHeading().ibr,
                                value: get(this.data, 'incomeBasedRepaymentResult.totalAmountPaid'),
                            },
                            {
                                title: this.tableHeading().icr,
                                value: get(this.data, 'incomeContingentRepaymentResult.totalAmountPaid'),
                            },
                            {
                                title: this.tableHeading().paye,
                                value: get(this.data, 'payAsYouEarnResult.totalAmountPaid'),
                            },
                            {
                                title: this.tableHeading().repaye,
                                value: get(this.data, 'repaymentPayAsEarnResult.totalAmountPaid'),
                            },
                        ],
                    },
                    {
                        name: 'totalForgiveness',
                        title: 'Total forgiveness',
                        type: 'balance',
                        fields: [
                            {
                                title: this.tableHeading().standard,
                                value: get(this.data, 'standard.totalForgiveness'),
                            },
                            {
                                title: this.tableHeading().ibr,
                                value: get(this.data, 'incomeBasedRepaymentResult.totalForgiveness'),
                            },
                            {
                                title: this.tableHeading().icr,
                                value: get(this.data, 'incomeContingentRepaymentResult.totalForgiveness'),
                            },
                            {
                                title: this.tableHeading().paye,
                                value: get(this.data, 'payAsYouEarnResult.totalForgiveness'),
                            },
                            {
                                title: this.tableHeading().repaye,
                                value: get(this.data, 'repaymentPayAsEarnResult.totalForgiveness'),
                            },
                        ],
                    },
                ];
            },
        },
        methods: {
            tableHeading() {
                return {
                    standard: constant.tableHeading.standard,
                    ibr: constant.tableHeading.ibr,
                    icr: constant.tableHeading.icr,
                    paye: constant.tableHeading.paye,
                    repaye: constant.tableHeading.repaye,
                };
            },
            getActiveTabData(value) {
                this.defaultChartLoad = value;
            },
            getVisualGraphCalculation() {
                const defaultData = this.defaultChartLoad ? this.defaultChartLoad : this.getVisualData[0].name;
                const defaultArray = this.getFields(defaultData);
                return this.visualResults(defaultArray.fields);
            },
            getVisualStoreTitles() {
                const defaultData = this.defaultChartLoad ? this.defaultChartLoad : this.getVisualData[0].name;
                const defaultArray = this.getFields(defaultData);
                return this.getResultParts(defaultArray.fields, defaultArray.type);
            },
            getFields(defaultData) {
                const filterData = this.getVisualData.filter(item => item.name === defaultData);
                if (!filterData) {
                    return {};
                }
                return {
                    fields: filterData[0].fields,
                    type: filterData[0].type,
                };
            },
            visualResults(fields) {
                const dataArray = [];
                fields.forEach((item, i) => {
                    const styles = {
                        STANDARD: 'green-lighten',
                        IBR: 'deep-blue-lighten',
                        ICR: 'salmon-lighten',
                        PAYE: 'teal-lighten',
                        REPAYE: 'green-lighten',
                    };
                    const className = styles[item.title];
                    const chartWidth = this.resultsPlacing(i + 1, fields);
                    dataArray.push({
                        name: item.title,
                        value: Accounting.format(Math.round(item.value)),
                        chartWidth,
                        class: className,
                    });
                });
                return dataArray;
            },
            resultsPlacing(idx, fields) {
                const insideWidth = parseInt(this.countResultWidth(fields, idx - 1), constant.radix.decimal);
                const outsideWidth = 100 - insideWidth;
                return {
                    insideWidth,
                    outsideWidth,
                };
            },
            countResultWidth(fields, idx) {
                const original = max(map(fields, p => Math.round(p.value)));
                const newState = parseInt(fields[idx].value, constant.radix.decimal);
                if (isNull(newState)) {
                    return 0;
                }
                if (isNaN(newState)) {
                    return 0;
                }
                if (original === 0) {
                    return 0;
                }
                if (newState === original) {
                    return 100;
                }
                return newState / original * 100;
            },
            getResultParts(fields, type) {
                if (!fields || compact(map(fields, f => Math.round(f.value))).length === 0) {
                    return [0];
                }
                const loan = max(map(fields, p => parseFloat(p.value)));
                const countPieces = 6;
                const value = loan / countPieces;
                const results = [];
                let splitter = 1;
                if (type === 'balance') {
                    if (loan >= 40000) {
                        splitter = 5000;
                    } else if (loan >= 7900 && loan < 40000) {
                        splitter = 1000;
                    } else if (loan >= 2000 && loan < 7900) {
                        splitter = 100;
                    } else if (loan > 1000 && loan < 2000) {
                        splitter = 10;
                    } else {
                        splitter = 1;
                    }
                } else if (loan > 100) {
                    splitter = 10;
                } else {
                    splitter = 1;
                }
                for (let i = 0; i < countPieces + 1; i++) {
                    results.push(Math.round(value * i / splitter) * splitter);
                }
                const lastMaxvalue = Math.max.apply(null, results);
                if (lastMaxvalue < loan) {
                    results[countPieces] = lastMaxvalue + splitter;
                }
                return results;
            },
            formattingForgivenessValue(number) {
                const roundValue = Math.round(number);
                if (roundValue === '-' || isNaN(roundValue) || roundValue === 0) {
                    return '-';
                }
                return `+$${Accounting.format(roundValue)}`;
            },
            formattingTableCellValue(number) {
                const roundValue = Math.round(number);
                if (roundValue === '-' || isNaN(roundValue)) {
                    return '-';
                }
                return `$${Accounting.format(roundValue)}`;
            },
            convertInYears(value) {
                if (value === '-') {
                    return '-';
                }
                const numberOfYears = (value || defaultNumberOfMonths) / 12;
                const valueWithDecimal = numberOfYears.toFixed(1);
                if (valueWithDecimal % parseInt(valueWithDecimal, constant.radix.decimal) === 0) {
                    return `${Math.round(valueWithDecimal)}yr`;
                }
                return `${valueWithDecimal}yr`;
            },
            formatValueWithComma(number) {
                return `$${Accounting.format(number)}`;
            },
        },

    };
</script>
